import { reportIssueStoreKey } from './reportIssue.const';
import { AppStateWithReportIssueData as State } from './reportIssue.types';

const select = (state: State) => state[reportIssueStoreKey];

const getApiStatus = (state: State) => select(state).apiStatus;

export const reportIssueDataSelector = {
  getApiStatus,
};
